import React, { useState, useEffect } from 'react';
import { Card, Row, Col, FormGroup } from 'react-bootstrap';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import CompDetails from './fromFormComponents/CompDetails';
import * as action from '../store/POTemplate.action';
import { ElementTemplate } from '../TemplateComponent';
import { usePOTemplateState } from '../P.O.TemplateContext/index';

function CompanyDetails({ element, eleIndex, fromForm, itemDragging, elementId }) {
  const [companyData, setCompanyData] = useState(null);
  const { duplicatingItem, deleteItem, editingInput, changeLabel, dropLocation, dropInLocation, deleteCard, modfiyReqAndEnable, inSave } = usePOTemplateState();

  const dispatch = useDispatch();
  const {
    poTemplateData: { compData },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    if (!isEmpty(element)) {
      setCompanyData({ ...element });
    }
  }, [element]);

  useEffect(() => {
    if (inSave && companyData && !compData) {
      dispatch(action.companyUpdate(companyData));
    }
  }, [inSave, companyData, dispatch, compData]);

  const onChangeComp = (value, label, i, index) => {
    const template = [...(companyData?.columns || [])];
    if (template[index][i].options) {
      const updatedOptions = template[index][i].options.map((e) => {
        if (e.name === label) {
          return { ...e, value };
        }
        return e;
      });
      template[index][i].options = updatedOptions;
    } else {
      template[index][i].value = value;
    }
    setCompanyData((previosState) => ({
      ...previosState,
      columns: template,
    }));
  };

  const changePosition = (item, index, i) => {
    const dragedItem = item?.col;
    const newColumns = companyData?.columns;
    newColumns[index].splice(i, 0, dragedItem);
    if (newColumns[item?.index][item?.i]?.id === newColumns[index][i]?.id) {
      newColumns[item?.index].splice(item?.i, 1); // very Important to be after new item is added
    } else {
      newColumns[item?.index].splice(item?.i + 1, 1);
    }

    setCompanyData((previousData) => ({
      ...previousData,
      columns: newColumns,
    }));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Card className="listing-card">
        <Card.Header className={fromForm ? 'px-2 py-2 bgcolor-dark d-flex' : 'px-2 py-2 bgcolor-dark'}>
          <strong onClick={() => changeLabel(companyData, eleIndex)}>{companyData?.label}</strong>
          {fromForm && itemDragging?.type !== 'container' && (
            <>
              <button
                className="btn btn-border ml-auto py-0 px-1"
                name="edit"
                aria-label="edit"
                type="button"
                key={`${element?.key}_${eleIndex}_edit`}
                onClick={() => modfiyReqAndEnable(companyData, eleIndex)}
              >
                <span className="icon-edit" />
              </button>
              <button
                type="button"
                aria-label="delete"
                className="btn btn-border py-0 px-1"
                key={`${element?.key}_${eleIndex}_delete`}
                onClick={() => deleteCard(eleIndex)}
              >
                <span className="icon-delete" />
              </button>
            </>
          )}
        </Card.Header>
        {itemDragging?.type !== 'container' && (
          <Card.Body className="py-4">
            <Row className="span_font_size">
              {companyData?.columns?.map((column, index) => {
                return (
                  <Col lg={6} key={index}>
                    {column?.map((col, i) => {
                      return (
                        <FormGroup key={i}>
                          {fromForm ? (
                            <CompDetails
                              col={col}
                              index={index}
                              i={i}
                              onChange={onChangeComp}
                              eleIndex={eleIndex}
                              dropLocation={dropLocation}
                              changePosition={changePosition}
                              dropInLocation={dropInLocation}
                              companyData={companyData}
                              fromForm={fromForm}
                              duplicatingItem={duplicatingItem}
                              editingInput={editingInput}
                              deleteItem={deleteItem}
                              elementId={elementId}
                            />
                          ) : (
                            <ElementTemplate
                              {...col}
                              keys={col?.key}
                              error={col?.hasError}
                              requiredField={col?.required}
                              disable
                              value={col?.value}
                              options={col?.options}
                              placeHolder={col?.placeholder ? `${col?.placeholder}` : `${col?.label}`}
                              fromForm={fromForm}
                              elementId={elementId}
                            />
                          )}
                        </FormGroup>
                      );
                    })}
                  </Col>
                );
              })}
            </Row>
          </Card.Body>
        )}
      </Card>
    </DndProvider>
  );
}

export default CompanyDetails;
